import { Image } from "./event";

export interface TicketType {
  id: string;
  name: string;
  description: string;
  image: { id: string; url: string } | null;
  supply: number | null;
  price: number | null;
  salesStart: string | null;
}

export interface MemberTicket {
  id: string;
  eventId: string;
  name: string;
  image: Image | null;
  description: string | null;
  createdAt: string;
}

export const defaultEventTicketType: TicketType = {
  id: "",
  name: "",
  description: "",
  image: null,
  supply: null,
  price: 0,
  salesStart: "",
};
